import { TLCEvents } from "../../../js/lib/events/events";
import { ApplicationData } from "../ls2pac/ApplicationData";
import { LS2PAC_Utils } from "../ls2pac/utils/Utils";
import { LS2KIDS_CONSTANTS } from "./constants";
import { KidsMessaging } from "./messaging";

export class KidsUtil {
	constructor() { }
	static onTouchStartTimingHack(e) {
		var touch = e.originalEvent.changedTouches[0];

		KidsUtil._startCoordinates = {
			x: touch.clientX,
			t: touch.clientY
		};
	}
	static onTouchEndTimingHack(e, callback) {
		if ($(e.target).hasClass('excludetiming-hack')) {
			return;
		}
		var touch = e.originalEvent.changedTouches[0];

		var coordinateDiff = {
			x: Math.abs(KidsUtil._startCoordinates.x - touch.clientX),
			y: Math.abs(touch.clientY - touch.clientY)
		};

		if (coordinateDiff.x < 10 && coordinateDiff.y < 10) {
			callback(e);
		}
	}
	static showBackdrop() {
		if (KidsUtil._backdrop == null) {
			KidsUtil._backdrop = $('<div class="backdrop"></div>');
			$("#app-main").append(KidsUtil._backdrop);
		}
	}
	static hideBackdrop() {
		if (KidsUtil._backdrop != null) {
			KidsUtil._backdrop.remove();
			KidsUtil._backdrop = null;
		}
	}
	static getAvailabilityIcon(resource) {
		var displayObject = LS2PAC_Utils.getAvailabilityDisplayObject(resource);
		var enableEResourceAvailability = ApplicationData.locationConfiguration.isKidsEnableEResourceAvailability();

		var availableIcon = $('<img />');

		var available = false;
		var askLibrarianForHelp = false;

		var currentBranch = ApplicationData.branchLimitsUtil.getCurrentBranchIfNotLimited();

		resource.noCopies = (displayObject.noCopies || (currentBranch && displayObject.localCopies == 0)) && !resource.downloadable;

		if (displayObject.downloadable) {
			if (enableEResourceAvailability && resource.eAvailabilities && resource.eAvailabilities.length > 0) {
				if (resource.availability) {
					availableIcon
						.data('available', true)
						.attr('alt', 'In')
						.addClass('availability-in')
						.attr('src', '/images/kids/downloadable-in.png');
					available = true;
				} else {
					availableIcon
						.data('available', false)
						.attr('alt', 'Out')
						.addClass('availability-out')
						.attr('src', '/images/kids/downloadable-out.png');
				}
			} else {
				availableIcon
					.attr('alt', 'Downloadable')
					.addClass('availability-downloadable')
					.attr('src', '/images/kids/downloadable.png');

				askLibrarianForHelp = true;
			}
		} else if (displayObject.count > 0) {
			availableIcon
				.data('available', true)
				.attr('alt', 'In')
				.addClass('availability-in')
				.attr('src', '/images/kids/in.png');

			available = true;
		} else {
			availableIcon
				.data('available', false)
				.attr('alt', 'Out')
				.addClass('availability-out')
				.attr('src', '/images/kids/out.png');
		}

		var newEle = $('<span></span>')
			.data('available', available)
			.addClass('availability')
			.append(availableIcon);


		var currentUser = ApplicationData.getCurrentUser();

		if (KidsUtil.canCheckoutResource(resource)) {
			KidsUtil.attachHoldEvent(newEle, resource, askLibrarianForHelp);

			newEle.addClass('holds-event-active');
		} else if (KidsUtil.canAddDownloadableSourceLink(resource)) {
			KidsUtil.addDownloadableSourceLink(newEle, resource);
		} else if (currentUser != null && currentUser.username == "tlcadmin") {
			KidsUtil.addTLCAdminNoHoldEvent(newEle);
		}

		return newEle;
	}
	static canCheckoutResource(resource) {
		var enableEResourceHoldsCheckouts = ApplicationData.locationConfiguration.isKidsEnableEResourceHoldsCheckouts();
		var currentUser = ApplicationData.getCurrentUser();

		return (ApplicationData.locationConfiguration.getAllowHolds().title || resource.downloadable) &&
			//		ApplicationData.locationConfiguration.isKidsEnableEResourceHoldsCheckouts() &&
			(resource.holdingsInformations.length > 0 || resource.downloadable) &&
			(currentUser == null || LS2PAC_Utils.isValidPatronIdUser(currentUser)) &&
			(
				(resource.downloadable && enableEResourceHoldsCheckouts && resource.eAvailabilities != null && resource.eAvailabilities.length > 0)
				|| (!resource.downloadable)
			);
	}
	static canAddDownloadableSourceLink(resource) {
		var correctVendorEnabled = resource.eResourceService == "overdrive"
			? ApplicationData.locationConfiguration.isOverDriveEnabled()
			: resource.eResourceService == "bakertaylor"
				? ApplicationData.locationConfiguration.isBakerAndTaylorEnabled()
				: resource.eResourceService == "mackin"
					? ApplicationData.locationConfiguration.isMackinEnabled()
					: false;

		var actionsEnabled = resource.eAvailabilities != null && resource.eAvailabilities.length > 0
			? resource.eAvailabilities[0].actionsEnabled &&
			ApplicationData.locationConfiguration.isKidsEnableEResourceHoldsCheckouts() &&
			correctVendorEnabled
			: false;

		var hasLink = resource.link != null && resource.link.length > 0;

		return resource.downloadable && !actionsEnabled && hasLink;
	}
	static addTLCAdminNoHoldEvent(ele, resource) {
		function holdEvent(e) {
			e.preventDefault();
			e.stopPropagation();

			KidsMessaging.showThenHide("Hey bro, you can't do that.", 5000);
		}

		ele
			.on('click', holdEvent)
			.on('touchstart', KidsUtil.onTouchStartTimingHack)
			.on('touchend', function (e) {
				KidsUtil.onTouchEndTimingHack(e, holdEvent);
			});
	}
	static addDownloadableSourceLink(ele, resource) {
		function holdEvent(e) {
			e.preventDefault();
			e.stopPropagation();

			window.open(resource.link);
		}

		ele
			.on('click', holdEvent)
			.on('touchstart', KidsUtil.onTouchStartTimingHack)
			.on('touchend', function (e) {
				KidsUtil.onTouchEndTimingHack(e, holdEvent);
			});
	}
	static shortTitle(data) {
		var maxStringLength = 75;
		var shortTitle = data.currentResource.shortTitle;

		if (shortTitle.length > maxStringLength) {
			shortTitle = shortTitle.substr(0, maxStringLength) + "...";
		}

		return shortTitle;
	}
	static appendFormatIcon(resource, linkEle) {
		var formatText = resource.format;

		if (formatText != null) {
			var formatIcon = KidsUtil.getFormatImage(formatText);
			var $imgIcon = $('<div data-title="' + formatText + '" class="format-icon"><img src="images/kids/formats/' + formatIcon + '" alt="' + formatText + '" /></div>');

			$imgIcon.tooltip({
				container: "body"
			});

			linkEle
				.addClass('has-format-icon')
				.append($imgIcon);
		}
	}
	static appendReadingLevelIcon(resource, linkEle) {
		if (!ApplicationData.locationConfiguration.areReadingLevelsEnabled()) {
			return;
		}

		var acceleratedReaderText = resource.acceleratedReader.bookLevel;
		var lexileText = resource.lexile.lexile;
		var textToUse = "";
		var readingLevelDisplaySetting = ApplicationData.locationConfiguration.displayReadingLevelKidsSearchResults();

		//console.log(readingLevelDisplaySetting);
		//if ( readingLevelDisplaySetting == "lexile" && ApplicationData.locationConfiguration.isLexileEnabled() && lexileText != null ) {
		//	textToUse = lexileText + "L";
		//} else if ( readingLevelDisplaySetting == "ar" && ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() && acceleratedReaderText) {
		//	textToUse = "AR " + acceleratedReaderText;
		//}
		if (ApplicationData.locationConfiguration.isLexileEnabled() && lexileText != null) {
			textToUse = lexileText + "L";
		} else if (ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() && acceleratedReaderText) {
			textToUse = "AR " + acceleratedReaderText;
		}

		if (textToUse != "" && textToUse.length > 0) {
			var $imgIcon = $('<div class="reading-level-info"><p>' + textToUse + '</p></div>');

			linkEle
				.append($imgIcon);
		}
	}
	static attachHoldEvent(ele, resource, askLibrarianForHelp) {
		function holdEvent(e) {
			TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onPromptToHoldResource, {
				resource: resource,
				available: ele.data('available'),
				event: e,
				askLibrarianForHelp: askLibrarianForHelp
			});

			e.preventDefault();
			e.stopPropagation();
		}

		ele
			.on('click', holdEvent)
			.on('touchstart', KidsUtil.onTouchStartTimingHack)
			.on('touchend', function (e) {
				KidsUtil.onTouchEndTimingHack(e, holdEvent);
			});
	}
	/**
	 *  Send an array in, and it will return a random one and remove it from the array (using splice)
	 *  Any other argument can be arrays that include excludes of what shouldn't return.
	 * @param arr
	 * @param {...*=} excludes any number of arrays to exclude a value to return
	 * @returns {*}
	 */
	static puntRandom(arr, excludes) {
		var check = false;
		var value = null;
		var index = null;

		while (!check) {
			index = Math.floor(Math.random() * arr.length);
			value = arr[index];

			check = true;

			var totalChecks = 0;
			var maxCount = 0;

			for (var i = 1, len = arguments.length; i < len; i += 1) {
				var array = arguments[i];
				maxCount += array.length;

				for (var k = 0, kLen = array.length; k < kLen; k += 1) {
					totalChecks += 1;
					var item = array[k];
					if (item == value) {
						check = false;
						break;
					}
				}
			}

			if (totalChecks == maxCount) {
				break;
			}
		}

		var val = arr.splice(index, 1);

		return val[0];
	}
	static isPortrait() {
		return window.innerHeight > window.innerWidth;
	}
	static getFormatImage(str) {
		var replaced = str.replace(/[^A-Za-z]/g, "");

		return KidsUtil._iconMap[replaced.toLowerCase()];
	}
}

KidsUtil._iconMap = {
	'archivalmixedmaterials': 'archival-mixed-materials.png',
	'atlas':                  'atlas.png',
	'audiobook':              'audiobook.png',
	'bluray':                 'bluray.png',
	'book':                   'book.png',
	'bookoncd':               'book-on-cd.png',
	'bookontape':             'book-on-tape.png',
	'braille':                'braille.png',
	'cartographicmaterial':   'cartographic-materials.png',
	'database':               'software.png',
	'drawing':                'picture.png',
	'dvd':                    'dvd.png',
	'eaudiobook':             'eaudiobook.png',
	'ebook':                  'ebook.png',
	'ejournal':               'ejournal.png',
	'emusic':                 'emusic.png',
	'eresource':              'electronic-resource.png',
	'evideo':                 'evideo.png',
	'globe':                  'cartographic-materials.png',
	'kit':                    'kit.png',
	'largeprint':             'large-print.png',
	'magazine':               'magazine.png',
	'map':                    'map.png',
	'microfiche':             'microfiche.png',
	'microfilm':              'microfilm.png',
	'music':                  'music.png',
	'musiccassette':          'cassette.png',
	'musiccd':                'music-cd.png',
	'newspaper':              'newspaper.png',
	'nonprojected':           'visual-materials.png',
	'object':                 'artifact.png',
	'painting':               'picture.png',
	'photograph':             'photograph.png',
	'picture':                'picture.png',
	'print':                  'print.png',
	'printedmusic':           'score.png',
	'projected':              'visual-materials.png',
	'serial':                 'continuing-resources.png',
	'slide':                  'slide.png',
	'software':               'software.png',
	'toy':                    'toy.png',
	'vhs':                    'vhs.png',
	'videorecording':         'video-recording.png',
	'videogamecdrom':         'cdrom.png',
	'website':                'website.png'
};

KidsUtil._timingHackStartCoordinates = null;



















